import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/tailwind.css";

const app = createApp(App).use(store).use(router);

// Make app instance available globally for api.js logout function
window.app = app;

app.mount("#app");
